import { useEffect } from "react";
import { StatusToast } from "@/components/StatusToast";
import { clearGlobalError, useGlobalError } from "@/lib/global-error-toast";

/** Renders a red toast whenever a query fails (set via QueryCache
 *  onError → setGlobalError). Auto-dismisses after 5s. Mount once,
 *  high in the tree.
 *
 *  Without this, a 500 from any /api/stats/* endpoint manifested as a
 *  silent empty table — the bug that hid `column ag.app_id does not
 *  exist` from us for hours on 2026-05-05.
 */
export function GlobalErrorToast() {
  const err = useGlobalError();
  useEffect(() => {
    if (!err) return;
    const t = setTimeout(() => clearGlobalError(err.id), 5000);
    return () => clearTimeout(t);
  }, [err]);
  if (!err) return null;
  return <StatusToast message={err.message} variant="error" />;
}
